import { useMutation } from "react-query";
import usePopup from "../../../../hooks/usePopup";
import { ResponseType } from "../../../../Types/ServicesType/servicesType";
import { PatientRegistrationDataType } from "../type/RegistrationDataType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {patientRegistrationApi} = api
const useGetByPatientMasterId = (onSuccess?: (data:PatientRegistrationDataType | null) => void) => {
  const { showSnackbar } = usePopup();
  return useMutation(
    async ({
      bookingId = null,
      patientMasterId,
    }: {
      bookingId?: string | null;
      patientMasterId: string;
    }): Promise<ResponseType<PatientRegistrationDataType>> => {
      const result = await instance.post(patientRegistrationApi.getByPatientMasterId, {
        clinicId,
        bookingId:bookingId ? Number(bookingId) : null,
        patientMasterId:Number(patientMasterId) || null,
      });
      return result.data;
    },
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          if (onSuccess) {
            onSuccess(result?.response || null);
          }
        } else {
          console.log("Something went wrong ! 1")
          showSnackbar({
            message: result?.responseMessage || "Something went wrong !",
            open: true,
            variant: "error",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        console.log("Something went wrong ! 2")
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );
};

export default useGetByPatientMasterId;
